var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qk-video"},[_c('video',{ref:_vm.refId,attrs:{"src":_vm.videoSrc,"loop":_vm.loop,"autoplay":_vm.autoPlay},domProps:{"muted":_vm.muted}})])
}
var staticRenderFns = []

export { render, staticRenderFns }